import  breakfast  from "../img/kindfood/breakfast.jpg"
import  mainFood  from "../img/kindfood/mainFood.jpg"
import  appetizer  from "../img/kindfood/appetizer.jpg"
import  frieds  from "../img/kindfood/fried.jpg"
import  pizza  from "../img/kindfood/napoli.jpg"
import  burgerAndSandwich  from "../img/kindfood/burger.jpg"
import  drinks  from "../img/kindfood/drinks.jpg"
import  coffee  from "../img/kindfood/coffee.jpg"
import  hotDrinkOnCoffee  from "../img/kindfood/hotDrinkOnCoffee.jpg"
import  hotDrink  from "../img/kindfood/hotDrink.jpg"
import  smooti  from "../img/kindfood/smooti.jpg"
import  moktel  from "../img/kindfood/moktel.jpg"
import  teaAndHerbal  from "../img/kindfood/herbalTea.jpg"
import  iceCoffee  from "../img/kindfood/iceCoffee.jpg"
import  cake  from "../img/kindfood/cack.jpg"
import  shake  from "../img/kindfood/shake.jpg"
import  iceCream  from "../img/kindfood/icecream.jpg"
import  hookah  from "../img/kindfood/hookah.jpg"
import iceTea from '../img/kindfood/icetea.jpg'
import fizzy from '../img/kindfood/fizzy.jpg'
import cooffee from '../img/kindfood/cooffee.jpg'
import other from '../img/kindfood/other.jpg'



export const kindFood=[
    {
        "id" : 0 ,
        "title" : "صبحانه",
        "idNmae":'breakfast',
        "image" : breakfast,
    },
    {
        "id" : 1 ,
        "title" : "غذای اصلی",
        "idNmae":'mainFood',
        "image" :mainFood,
    },
    {
        "id" : 2 ,
        "title" : "پیش غذا",
        "idNmae":'appetizer',
        "image" :appetizer,
    },
    {
        "id" : 3 ,
        "title" : "سوخاری",
        "idNmae":'frieds',
        "image" :frieds,
    },
    // {
    //     "id" : 4 ,
    //     "title" : "پیتزا",
    //     "idNmae":'pizza',
    //     "image" :pizza,
    // },
    {
        "id" : 24 ,
        "title" : "پیتزا ناپولی",
        "idNmae":'italiaPizza',
        "image" :pizza,
    },
    {
        "id" : 5 ,
        "title" : "برگر و ساندویچ",
        "idNmae":'burgerAndSandwich',
        "image" :burgerAndSandwich,
    }, 
    {
        "id" : 23 ,
        "title" : "وگان",
        "idNmae":'vegan',
        "image" :other,
    }, 
    {
        "id" : 6 ,
        "title" : "نوشیدنی",
        "idNmae":'drinks',
        "image" :drinks,
    }, 
    {
        "id" : 19 ,
        "title" : "نوشیدنی‌های گازدار",
        "idNmae":'fizzy',
        "image" :fizzy,
    }, 
    {
        "id" : 7 ,
        "title" : "قهوه ها",
        "idNmae":'coffee',
        "image" :coffee,
    }, 
    {
        "id" : 21 ,
        "title" : "قهوه های دمی",
        "idNmae":'cooffee',
        "image" :cooffee,
    }, 
    {
        "id" : 8 ,
        "title" : "نوشیدنی گرم بر پایه قهوه",
        "idNmae":'hotDrinkOnCoffee',
        "image" :hotDrinkOnCoffee,
    }, 
    {
        "id" : 9 ,
        "title" : "نوشیدنی های گرم",
        "idNmae":'hotDrink',
        "image" :hotDrink,
    }, 
    {
        "id" : 10 ,
        "title" : "اسموتی",
        "idNmae":'smooti',
        "image" :smooti,
    }, 
    {
        "id" : 11 ,
        "title" : "ماکتل",
        "idNmae":'moktel',
        "image" :moktel,
    }, 
    {
        "id" : 12 ,
        "title" : "چای و دمنوش",
        "idNmae":'teaAndHerbal',
        "image" :teaAndHerbal,
    }, 
    {
        "id" : 13 ,
        "title" : "آیس کافی",
        "idNmae":'iceCoffee',
        "image" :iceCoffee,
    }, 
    {
        "id" : 18 ,
        "title" : "آیس تی",
        "idNmae":'iceTea',
        "image" :iceTea,
    }, 
    {
        "id" : 14 ,
        "title" : "کیک و چیز کیک",
        "idNmae":'cake',
        "image" :cake,
    }, 
    {
        "id" : 15 ,
        "title" : "شیک",
        "idNmae":'shake',
        "image" :shake,
    }, 
    {
        "id" : 16 ,
        "title" : "بستنی و کیک بستنی",
        "idNmae":'iceCream',
        "image" :iceCream,
    }, 
    {
        "id" : 17 ,
        "title" : "قلیان",
        "idNmae":'ghelian',
        "image" :hookah,
    }, 
    // {
    //     "id" : 20 ,
    //     "title" : "غذای ایرانی",
    //     "idNmae":'irani',
    //     "image" :mainFood,
    // }, 
    {
        "id" : 22 ,
        "title" : "سایر",
        "idNmae":'other',
        "image" :other,
    }, 
    
]